import { render, staticRenderFns } from "./CommandsTab.vue?vue&type=template&id=5b206a5a&scoped=true"
import script from "./CommandsTab.vue?vue&type=script&lang=js"
export * from "./CommandsTab.vue?vue&type=script&lang=js"
import style0 from "./CommandsTab.vue?vue&type=style&index=0&id=5b206a5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b206a5a",
  null
  
)

export default component.exports